import { Component, Input } from '@angular/core';

@Component({
    selector: 'spinner',
    styleUrls: ['./spinner.component.scss'],
    templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
    @Input() public show: boolean; // ngIf ???
    @Input() public color: 'red' | 'green' | 'gray' | 'white' = 'green';
    @Input() public message: string;
}
